<template>
  <div>
    <div class="row justify-content-center mt-5 mb-5">
      <div class="col-md-10">
        <form
          class="form-horizontal "
          role="form"
        >
          <h3 class="d-flex justify-content-center">
            {{ memberpackage.ref_number }}:
            {{ getLocalPackageFull(memberpackage.package) }}
          </h3>
          <hr />
          <div class="form-inline text-center justify-content-center mb-3">
            <label
              for="session_max"
              class="control-label mr-3"
            >Total Sessions</label>
            <input
              type="text"
              id="session_max"
              placeholder="Total Sessions"
              class="form-control"
              autofocus
              v-model="memberpackage.session_max"
            />
          </div>

          <div class="form-group text-center">
            <label
              for="activate_date"
              class="control-label mr-3"
            >Activate Date</label>
            <date-picker
              v-model="memberpackage.activate_date"
              valueType="format"
            ></date-picker>
          </div>
          <div class="form-group text-center">
            <label
              for="expire_date"
              class="control-label mr-3"
            >Expire Date</label>

            <date-picker
              v-model="memberpackage.expire_date"
              valueType="format"
            ></date-picker>
          </div>

          <div class="form-group text-center">
            <label
              for="Note"
              class="control-label mr-3"
            >Note</label>
            <textarea
              id="text"
              cols="40"
              rows="2"
              placeholder="Add text here"
              v-model="memberpackage.note"
            ></textarea>
          </div>

          <div
            class="form-check text-center"
            v-if="memberpackage.status != 'INACTIVE'"
          >
            <input
              type="checkbox"
              class="form-check-input"
              id="memberpackage_status"
              v-model="isfreeze"
              value="FREEZE"
            />
            <label
              class="form-check-label ml-3"
              for="memberpackage_status"
            >Freeze <i class="fas fa-snowflake handblue"></i></label>
          </div>

          <!--
          <div class="form-group">
            <label for="birthDate" class="col-sm-3 control-label"
              >Date of Birth</label
            >
            <div class="">
              <input type="date" id="birthDate" class="form-control" />
            </div>
          </div>
          -->
          <div
            class="form-group text-center"
            v-if="isfreeze"
          >
            <label
              for="freeze_date"
              class="control-label mr-3"
            >Freeze Date</label>

            <date-picker
              v-model="memberpackage.freeze_date"
              valueType="format"
            ></date-picker>
            ({{ getDurationFromFreezedate(memberpackage.freeze_date) }} Days to now)
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block mt-3"
            @click.prevent="updateMemberPackage"
          >
            Update
          </button>
          <transition name="slide-fade">
            <div
              class="alert alert-danger mt-2"
              role="alert"
              v-if="isUpdateError"
            >
              Cannot update package! Something Wrong..
            </div>
          </transition>
        </form>
        <!-- /form -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { getPackageFull } from "./../js/utils/datamanip.js";
export default {
  props: ["memberpackage"],
  data() {
    return {
      /* memberpackage: {
        ref_number: "100354",
        firstname: "Chor",
        lastname: "Chaa",
        email: "aa@aa.com",
        phone: "08451516",
      }, */
      loading: false,
      isUpdateError: false,
      isfreeze: false
    };
  },
  components: { DatePicker },
  computed: {},
  mounted() {
    //this.memberpackage = this.memberpackage;
    /* console.log(this.memberpackage);
    this.memberpackage.session_max = 800;
    console.log(this.memberpackage); */
    //this.checkedNames.push(this.$refs.precheck.value);
    //console.log(this.memberpackage);
    if (this.memberpackage.status == "FREEZE") {
      this.isfreeze = true;
    }
  },
  methods: {
    async updateMemberPackage() {
      this.loading = true;
      this.isUpdateError = false;
      //this.errors = null;
      let self = this;

      if (
        this.memberpackage.session_max == "" ||
        this.memberpackage.activate_date == "" ||
        this.memberpackage.expire_date == ""
      ) {
        this.isUpdateError = true;
        return false;
      }

      //console.log(this.memberpackage);
      //console.log(this.isfreeze);
      await axios
        .post("/api/members/updatepackage", {
          memberpackage: this.memberpackage,
          isfreeze: this.isfreeze
        })
        .then(response => {
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          //this.isUpdateCompleted = true;
          //this.$store.dispatch("setSaleMember", response.data);
          this.$emit("close");
        })
        .catch(function(error) {
          //console.log(error.response.status);
          //console.log(error.response.data.error);
          //if(error.response.data.errors.message =)
          let errormsg = error.response.data.error;
          if (error.response.status == 500) {
            self.isUpdateError = true;
          }
        })
        .finally(() => (this.loading = false));
    },
    getLocalPackageFull(key) {
      return getPackageFull(key);
    },
    getDurationFromFreezedate(date) {
      if (date == null) return 0;
      return moment(new Date().toISOString().slice(0, 10), "YYYY-MM-DD").diff(
        moment(date, "YYYY-MM-DD"),
        "days"
      );
    }
  }
};
</script>
<style scoped>
#memberpackage_status {
  width: 30px;
  height: 30px;
}
.form-check-label {
  font-size: 1.5em;
}
.handblue {
  font-size: 1.5em;
  color: blue;
}
</style>
